import React from "react";
import { SlideHome } from "../../components/home/SlideHome";
import { Partenaire } from "../../components/home/nosPartenaire";
import { Experience } from "../../components/home/experience";
import { Realisation } from "../../components/home/realisation";
import { Prestations } from "../../components/home/prestations";
import { Question } from "../../components/home/question";
import { Pourquoi } from "../../components/home/pourquoi";
import { Temoignage } from "../../components/home/temoignage";
import { DemandeDevis } from "../../components/home/demandeDevis";
import ContactSection from "../../components/home/contactForm";
import StickyButtons from "../../components/stickyButtons";
import rea1 from "../../assets/images/rea1.png";
import rea2 from "../../assets/images/rea2.png";
import rea3 from "../../assets/images/rea3.png";
export const HomePage = () => {
  const realisations = [
    {
      image: rea1,
      text: "Isolation de toiture",
      link: "/toiture",
    },
    {
      image: rea2,
      text: "Isolation exterieur",
      link: "/ITE",
    },
    {
      image: rea3,
      text: "Isolation intérieure",
      link: "/ITI",
    },
  ];
  return (
    <div>
      <SlideHome />
      <StickyButtons />
      <Partenaire />
      <Experience />
      <Realisation realisations={realisations} />
      <Prestations
        title={"Nos prestations"}
        description={
          "        Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
      <Question />
      <Pourquoi />
      <Temoignage />
      <DemandeDevis title={"Obtenez votre devis gratuit sous 48h"} />
      <ContactSection />
    </div>
  );
};
